import { HTMLAttributes } from "react";
import { IconButtonContainer } from "./DatePickerButton.elements"
import { ChevronRight  } from "icons/indexed-icons/ChevronRight";

  
export interface ArrowButtonProps extends HTMLAttributes<HTMLButtonElement> {
  left?: boolean;
  right?: boolean;
  up?: boolean;
  down?: boolean;
}

export const ArrowButton = (props: ArrowButtonProps): JSX.Element => {
  
  const { left, right, up, down, color, ...rest} = props    
  rest.className = `${left ? 'left' : right ? 'right' : up ? 'up' : down ? 'down' : ''} ${rest?.className || ''}`.trim()

  return (
    <IconButtonContainer {...rest}>
      <ChevronRight {...{color}} />
    </IconButtonContainer>
  );
}